import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { BASE_URL, getCall } from "../../utils/api";
import axios from "axios";
import toast from "react-hot-toast";

const initialState = {
  data: [],
  error: "",
  status: "idle",
  isUpdateStatus: "idle",
};

export const getPrivacyPolicy = createAsyncThunk(
  "PrivacyPolicy/get",
  async (type) => {
    try {
      const response = await getCall(`/admin/v1/cms_pages?type=${type}`, false);
      return await response?.data;
    } catch (error) {
      return Promise?.reject(error);
    }
  }
);

export const updatePrivacyPolicy = createAsyncThunk(
  "PrivacyPolicy/updatePrivacyPolicy",
  async ({ type, formData }, { rejectWithValue, dispatch }) => {
    const token = JSON.parse(localStorage.getItem("token"));
    try {
      const response = await axios.post(
        `${BASE_URL}/admin/v1/cms_pages/${type}`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: `Bearer ${token}`,
          },
        }
      );
      toast.success(response.data.message || "CMS updated successfully!");
      dispatch(getPrivacyPolicy(type));

      return response.data;
    } catch (error) {
      toast.error(error.response?.data?.message || "Failed to update");
      return rejectWithValue(error.response.data);
    }
  }
);

const PrivacyPolicySlice = createSlice({
  name: "privacyPolicy",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getPrivacyPolicy.pending, (state) => {
        state.status = "loading";
      })
      .addCase(getPrivacyPolicy.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.data = action.payload;
      })
      .addCase(getPrivacyPolicy.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.error.message || "An unknown error occurred";
      })
      .addCase(updatePrivacyPolicy.pending, (state) => {
        state.isUpdateStatus = "loading";
        state.error = null;
      })
      .addCase(updatePrivacyPolicy.fulfilled, (state, action) => {
        state.isUpdateStatus = "succeeded";
        if (state?.data?.id === action.payload.data.id) {
          state.data.data = action.payload.data;
        }
      })
      .addCase(updatePrivacyPolicy.rejected, (state, action) => {
        state.isUpdateStatus = "failed";
        state.error = action.error.message || "An unknown error occurred";
      });
  },
});

export default PrivacyPolicySlice.reducer;
